import React from "react";
import { Box, Typography } from "@mui/material";

const OrderSummary = ({ payment, discounts }) => (
  <Box mb={2}>
    <Typography variant="body2">
      Subtotal: ${payment.subtotal.toFixed(2)}
    </Typography>
    {discounts.length > 0 && (
      <Typography variant="body2" color="error">
        Discount: -${discounts.reduce((sum, d) => sum + d.amount, 0).toFixed(2)}
      </Typography>
    )}
    {payment.deliveryFee > 0 && (
      <Typography variant="body2">
        Delivery: ${payment.deliveryFee.toFixed(2)}
      </Typography>
    )}
    <Typography variant="body2">Tax: ${payment.tax.toFixed(2)}</Typography>
    <Typography fontWeight={600}>
      Total: ${payment.total.toFixed(2)} CAD
    </Typography>
  </Box>
);

export default OrderSummary;
